import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const A = () => {
    const { t } = useLang('discharge.A');
    return (
        <div className={`${css.page}`}>
            <div className="discharge-A-title">{t('title')}</div>
            <div>{t('text1')}</div>
            <div>{t('text2')}</div>
            <div>{t('text3')}</div>
            <div>{t('text4')}</div>
            <div className="module">
                <div className="module-title">{t('module1.title')}</div>
                <div>{t('module1.text')}</div>
                <ul className="module-list">
                    <li>
                        {t.rich('module1.li1', {
                            d: (v: string) => <span className="desc">{v}</span>,
                        })}
                    </li>
                    <li>
                        {t.rich('module1.li2', {
                            d: (v: string) => <span className="desc">{v}</span>,
                        })}
                    </li>
                    <li>
                        {t.rich('module1.li3', {
                            d: (v: string) => <span className="desc desc2">{v}</span>,
                        })}
                    </li>
                    <li>
                        {t.rich('module1.li4', {
                            d: (v: string) => <span className="desc desc2">{v}</span>,
                        })}
                    </li>
                </ul>
            </div>
            <div className="module">
                <div className="module-title">{t('module2.title')}</div>
                <div>{t('module2.text')}</div>
                <ul className="module-list">
                    <li>{t('module2.li1')}</li>
                    <li>{t('module2.li2')}</li>
                    <li>{t('module2.li3')}</li>
                    <li>{t('module2.li4')}</li>
                    <li>{t('module2.li5')}</li>
                </ul>
            </div>
            <div className="module" style={{ marginTop: -20 }}>
                <div className="module-title">{t('module3.title')}</div>
                <ul className="module-list" style={{ marginTop: -10 }}>
                    <li className="item2">
                        {t.rich('module3.email', {
                            l: (v: string) => (
                                <a className="recall-link" href="mailto:efdelta.support@ecoflow.com">
                                    {v}
                                </a>
                            ),
                        })}
                    </li>
                    <li className="item2">
                        {t.rich('module3.tel', {
                            l: (v: string) => (
                                <a className="recall-link" href="tel:050‐3355‐3196">
                                    {v}
                                </a>
                            ),
                        })}
                    </li>
                </ul>
            </div>
            <div className="A-sign">
                <div>{t('sign')}</div>
                <div className="text-left">{t('signTime')}</div>
                <div className="A-sign-name">
                    <div>{t('sign2')}</div>
                </div>
            </div>
        </div>
    );
};
export default A;
